// @ts-check
import {
  service,
  swanAccountStatus,
  swanOnboardingState
} from '@/core/constants'
import { companyGetters } from '@/store/modules/companyData'
import { getUnixTime } from 'date-fns'

export const TRACK = {
  FOUNDING_BUSINESS: '/no-business-id',
  EXISTING_BUSINESS: '/has-business-id'
}

const foundingStatus = (company) => {
  /*
   * If company has no wizard_completed return empty string
   * otherwise if company has founding_status it's been registered
   * via UKKO.fi service so return accordingly
   */
  if (!company.wizard_completed) {
    return ''
  }

  return company.founding_status ? 'service' : 'other'
}

export const pushToLayer = (data) => {
  if (!window.dataLayer) {
    return
  }

  window.dataLayer.push(data)
}

export const setMobileFlag = (isMobileWrapperUser) => {
  pushToLayer({
    mobileApplication: isMobileWrapperUser
  })
}

export const setPaymentCardAdded = (card) => {
  pushToLayer({
    paymentCardAdded:
      !!card.card_number ||
      !!card.card_type ||
      !!card.exp_month ||
      !!card.exp_year
  })
}

/** @param {{ company: CompanyResource, user?: UserResource }} params */
export const updateCompany = ({ company, user }) => {
  const environmentInitial =
    process.env.VUE_APP_SERVICE === service.UKKOPRO ? 'P' : 'N'
  const ukkoAssurance = company?.feature?.ukko_assurance
  const ukkoAssuranceEnabled = ukkoAssurance?.enabled === true ? '1' : '0'

  pushToLayer({
    companyId: `${environmentInitial}-${company.id}`,
    contentlanguage: localStorage.getItem('language') ?? 'fi',
    email: company.email,
    companyIndustry: company.company_industry_number,
    name: company.name,
    createdInvoice: company.first_invoice_sent,
    created_at: company.wizard_completed
      ? getUnixTime(new Date(company.wizard_completed))
      : undefined,
    ukkoAssuranceEnabled,
    isPayingCustomer: company.is_paying_customer,
    isCourier: companyGetters.isCourier({ company }),
    serviceFee: company.service_fee,
    fixedTermSubscriptionEndDate: company.fixed_term_subscription_end_date,
    cumulativeRevenue: company.cumulative_revenue,
    businessIdCreated: foundingStatus(company),
    hasSwanAccount: [
      swanAccountStatus.CONNECTED,
      swanAccountStatus.PENDING
    ].includes(company.swan_status),
    swanAccountOnboardingPending: [swanOnboardingState.ONGOING].includes(
      company.swan_onboarding_state
    ),
    ukkoPlus: company?.feature?.ukko_plus?.enabled ?? false,
    user_email: user?.email
  })
}

export const resetUser = () => {
  pushToLayer({
    companyId: null,
    email: null,
    name: null,
    createdInvoice: null,
    created_at: null,
    companyIndustry: null,
    contentlanguage: null,
    isPayingCustomer: null,
    isCourier: null,
    serviceFee: null,
    fixedTermSubscriptionEndDate: null,
    cumulativeRevenue: null,
    hasSwanAccount: null
  })
}

export const setupAnalyticsForExistingBusiness = () => {
  if (window.fbq) {
    window.fbq('track', 'CompleteRegistration')
  }

  pushToLayer({
    virtualPath: TRACK.EXISTING_BUSINESS
  })
}

export const setupAnalyticsForFoundingBusiness = () => {
  if (window.fbq) {
    window.fbq('track', 'Lead')
  }

  pushToLayer({
    virtualPath: TRACK.FOUNDING_BUSINESS
  })
}

export const updateAnalyticsForCompletedRegistration = ({ track }) => {
  if (!Object.values(TRACK).includes(track)) {
    throw new Error('Invalid track!')
  }

  pushToLayer({
    event: 'registrationComplete',
    service: process.env.VUE_APP_SERVICE,
    track
  })
}
